<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("issue.title") }}</h1>
    <b-tabs content-class="mt-3">
      <b-tab :title="this.$i18n.t('issue.issue')" active>
        <b-card class="w-50">
          <form>
            <b-form-group
              id="type"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('issue.model_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="selected" :options="options" class="mb-3"></b-form-select>
            </b-form-group>
            <b-form-group
              id="qty"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('issue.issuenum')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="qty" :placeholder="this.$i18n.t('issue.num_input')" maxlength="6"></b-form-input>
            </b-form-group>
            <b-form-group
              id="note"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('issue.note')"
              label-for="input-horizontal"
            >
              <b-form-textarea id="textarea" v-model="note" rows="3" max-rows="6" maxlength="500"></b-form-textarea>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="issue" class="float-right px-5">{{ $i18n.t("issue.issue") }}</b-button>
            </div>
          </form>
        </b-card>
      </b-tab>
      <b-tab :title="this.$i18n.t('issue.history')">
        <b-card class="w-50 mb-3">
          <form>
            <b-form-group
              id="select_type"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('issue.model')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="selected" :options="options" class="mb-3"></b-form-select>
            </b-form-group>
            <b-form-group
              id="select_date"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('issue.issue_date')"
              label-for="input-horizontal"
            >
              <div class="d-flex align-items-center">
                <div class="flex-fill">
                  <b-form-input id="from" v-model="from" type="date"></b-form-input>
                </div>
                <div class="flex-shrink-1 px-2" align="center">-</div>
                <div class="flex-fill">
                  <b-form-input id="to" v-model="to" type="date"></b-form-input>
                </div>
              </div>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="search" class="float-right px-5">{{ $i18n.t("issue.search") }}</b-button>
            </div>
          </form>
        </b-card>
        <b-card v-if="isSearch">
          <b-row>
            <b-col sm="5" md="1" class="my-1">
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
            </b-col>
            <b-col sm="7" md="11" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
          <b-table
            :striped="striped"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :current-page="currentPage"
            :per-page="perPage"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :no-border-collapse="noCollapse"
            :items="items"
            :fields="fields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
          >
            <template v-slot:cell(download)="row">
              <b-button
                size="sm"
                variant="primary"
                @click="download(row.item, row.index, $event.target)"
              >{{ $i18n.t("issue.button_download") }}</b-button>
            </template>
            <template v-slot:cell(edit)="row">
              <b-button size="sm" class="mr-2" @click="edit(row.item, row.index, $event.target)">{{ $i18n.t("issue.edit") }}</b-button>
            </template>
          </b-table>
        </b-card>
      </b-tab>
    </b-tabs>
    <issueModal modId="md-download" :msg="this.$i18n.t('issue.complete')" :titleMsg="this.$i18n.t('issue.issue')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @issueContinue="issueContinue" @download="downloadIssue"/>
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'
import issueModal from './IssueModal'

export default {
  components: {
    confirmModal,
    issueModal
  },
  data () {
    return {
      pageOptions: [10, 20, 50, 100],
      selected: null,
      qty: null,
      note: null,
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      options: [
        { value: null, text: this.$i18n.t('issue.model_input') }
      ],
      fields: [
        { key: 'mo', label: this.$i18n.t('issue.mo'), sortable: true },
        { key: 'issuer', label: this.$i18n.t('issue.issue_qty'), sortable: true },
        { key: 'date', label: this.$i18n.t('issue.issue_date'), sortable: true },
        { key: 'type', label: this.$i18n.t('issue.model'), sortable: true },
        { key: 'num', label: this.$i18n.t('issue.download_count'), sortable: true },
        { key: 'note', label: this.$i18n.t('issue.note'), sortable: true },
        { key: 'download', label: this.$i18n.t('issue.download_qty') },
        { key: 'edit', label: this.$i18n.t('issue.edit') }
      ],
      items: [
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      isSearch: false,
      errMsg: null,
      errSbj: null,
      mo: null,
      code: null,
      rev: null,
      dlQty: null
    }
  },
  methods: {
    search: function () {
      // リクエストパラメータ
      var body = {}
      // local -> utc 変換＆フォーマット
      if (this.from !== '') {
        var from = this.$moment(this.from, 'YYYY-MM-DD').hour(0).minutes(0).second(0)
        var startDate = from.utc().format('YYYY-MM-DD HH:mm:ss')
        body.startdate = startDate
      }
      if (this.to !== '') {
        var to = this.$moment(this.to, 'YYYY-MM-DD').hour(23).minutes(59).second(59)
        var endDate = to.utc().format('YYYY-MM-DD HH:mm:ss')
        body.enddate = endDate
      }
      if (this.selected != null) {
        var selected = this.selected.split(',')
        body.code = selected[0]
        body.rev = selected[1]
      }

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/plan/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var planList = res.data.list
            var plans = []

            if (planList.length === 0) {
              this.isSearch = false
              this.errSbj = this.$i18n.t('issue.title')
              this.errMsg = this.$i18n.t('issue.err_not_data')
              this.$bvModal.show('md-err')
              return
            }

            // 整形
            for (var i = 0; i < planList.length; i++) {
              var plan = {}
              plan.issuer = planList[i].count
              // utc -> local 変換
              // momentオブジェクト(UTC)に変換
              var utc = this.$moment.utc(planList[i].u_date, 'YYYY-MM-DD HH:mm:ss')
              var output = null
              if (String(utc) === 'Invalid date') {
                output = ''
              } else {
                // local時刻に変換＆フォーマット
                output = utc.local().format('YYYY-MM-DD')
              }
              plan.date = output
              plan.type = planList[i].code + ' - ' + planList[i].rev + ' - ' + planList[i].petname
              plan.code = planList[i].code
              plan.rev = planList[i].rev
              plan.petname = planList[i].petname
              plan.num = planList[i].download
              plan.note = planList[i].comment
              plan.mo = planList[i].mo
              plans.push(plan)
            }
            // ページング設定
            this.totalRows = plans.length
            // 一旦データクリア
            this.items.splice(0)
            // データセット
            this.items.splice(0, 0, ...plans)
            // 検索結果表示
            this.isSearch = true
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    issue: function () {
      if (!this.isValid()) {
        return
      }

      // Body
      var body = {}
      if (this.selected != null) {
        var selected = this.selected.split(',')
        body.code = selected[0]
        body.rev = selected[1]
        // 発行後のダウンロード画面遷移時に渡す値をセット
        this.petname = selected[2]
      }
      body.qty = this.qty
      body.remarks = this.note

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/issue/issue', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-download')
            this.mo = res.data.info.mo
            this.code = res.data.info.code
            this.rev = res.data.info.rev
            this.dlQty = res.data.info.qty
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    downloadIssue: function () {
      this.selected = null
      this.qty = null
      this.$bvModal.hide('md-confirm')
      this.downloadFromIssue(this.mo, this.code, this.rev, this.petname, this.dlQty, this.note)
      this.note = null
      this.qty = null
      this.$bvModal.hide('md-download')
    },
    issueContinue: function () {
      this.selected = null
      this.note = null
      this.qty = null
      this.$bvModal.hide('md-download')
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    },
    download: function (item, index, button) {
      this.$store.store.state.downloadId = item.mo
      this.$store.store.state.code = item.code + ' - ' + item.rev + ' - ' + item.petname
      this.$store.store.state.issuer = item.issuer
      this.$store.store.state.note = item.note
      this.$store.store.state.date = item.date
      this.$router.push({ path: 'issueDownload' })
    },
    edit: function (item, index, button) {
      this.$store.store.state.editId = item.mo
      this.$store.store.state.title = item.code + ' - ' + item.rev + ' : ' + item.issuer
      this.$router.push({ path: 'issueEdit' })
    },
    downloadFromIssue: function (mo, code, rev, petname, qty, note) {
      // シリアル発行後ダウンロード画面に遷移
      this.$store.store.state.downloadId = mo
      this.$store.store.state.code = code + ' - ' + rev + ' - ' + petname
      this.$store.store.state.issuer = qty
      this.$store.store.state.note = note

      // 発行日を出力
      var now = new Date()
      var formatdate = 'YYYY-MM-DD'
      formatdate = formatdate.replace('YYYY', now.getFullYear())
      formatdate = formatdate.replace('MM', now.getMonth() + 1)
      formatdate = formatdate.replace('DD', now.getDate())
      this.$store.store.state.date = formatdate

      this.$router.push({ path: 'issueDownload' })
    },
    isValid: function () {
      if (this.selected == null) {
        // 型番未選択
        this.errSbj = this.$i18n.t('issue.model')
        this.errMsg = this.$i18n.t('issue.err_model_hissu')
        this.$bvModal.show('md-err')
        return false
      } else if (this.qty == null) {
        // 製造数未入力
        this.errSbj = this.$i18n.t('issue.issuenum')
        this.errMsg = this.$i18n.t('issue.err_qty_hissu')
        this.$bvModal.show('md-err')
        return false
      } else if (!window.checkNum(this.qty) || this.qty <= 0) {
        // 1以上の数字で
        this.errSbj = this.$i18n.t('issue.issue_qty')
        this.errMsg = this.$i18n.t('issue.err_qty_number')
        this.$bvModal.show('md-err')
        return false
      } else if (this.note !== null && this.note.length > 500) {
        // 500文字より大きい
        this.errSbj = this.$i18n.t('issue.note')
        this.errMsg = this.$i18n.t('issue.err_note_sizeover')
        this.$bvModal.show('md-err')
        return false
      } else {
        return true
      }
    }
  },
  created () {
    this.from = window.formatDate(new Date(), 'yyyy-MM-dd')
    this.to = window.formatDate(new Date(), 'yyyy-MM-dd')

    var headers = {
      'Content-Type': 'application/json',
      'opId': this.$store.store.state.opId,
      'ticketId': this.$store.store.state.ticketId
    }

    var body = {}
    body.efFlg = '1'

    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.$axios
      .post(window.END_POINT + '/master/productinfo/select', body, {
        'headers': headers
      })
      .then(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err')
          }
        } else {
          var modelList = res.data.productInfo
          if (res.data.productInfo == null || res.data.productInfo.length === 0) {
            return
          }
          var options = []

          // 整形
          for (var i = 0; i < modelList.length; i++) {
            var option = {}
            option.value = modelList[i].code + ',' + modelList[i].rev + ',' + modelList[i].petname
            option.text = modelList[i].code + ' - ' + modelList[i].rev + ' - ' + modelList[i].petname
            options.push(option)
          }
          // 一旦データクリア
          this.options.splice(1)
          // データセット
          this.options.splice(1, 0, ...options)
        }
      })
      .catch(err => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(err)
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('common.unexpected_error')
        this.$bvModal.show('md-err')
      })
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Issue.vue